import storeApp from "@/store/app";
import storeWidget from "@/store/widget";
export const getStore = () => {
    return process.env["VUE_APP_IS_WIDGET"] === "true" ? storeWidget : storeApp;
};
